/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import styles from './tab.module.scss'

/**
 * A single tab component - should be wrapped in `TabGroup`.
 */
export default function Tab({ name, children }) {
  return (
    <div data-tab-name={name} className={styles.tab}>
      {children}
    </div>
  )
}

Tab.propTypes = {
  /** A unique ID of a tab */
  name: PropTypes.string.isRequired,
  /** Tab title */
  title: PropTypes.string.isRequired,
  /** Disabled tab button */
  disabled: PropTypes.bool,
}
